import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ButtonTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ButtonTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.ButtonTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.ButtonTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ButtonTypeConst.PLACEHOLDER),
        label: _ctx.getPropertyValue(_ctx.ButtonTypeConst.LABEL),
        icon: _ctx.getPropertyValue(_ctx.ButtonTypeConst.ICON),
        iconPos: _ctx.getCatalogValue(_ctx.ButtonTypeConst.ICONPOS),
        iconClass: _ctx.getPropertyValue(_ctx.ButtonTypeConst.ICONCLASS),
        badge: _ctx.getPropertyValue(_ctx.ButtonTypeConst.BADGE),
        link: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.LINK),
        severity: _ctx.getCatalogValue(_ctx.ButtonTypeConst.SEVERITY),
        raised: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.RAISED),
        rounded: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.ROUNDED),
        outline: _ctx.getPropertyValue(_ctx.ButtonTypeConst.OUTLINE),
        plain: _ctx.getPropertyBooleanValue(_ctx.ButtonTypeConst.PLAIN),
        size: _ctx.getCatalogValue(_ctx.ButtonTypeConst.SIZE),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.processEventComponent(_ctx.CatalogEventConst.CLICK)))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "label", "icon", "iconPos", "iconClass", "badge", "link", "severity", "raised", "rounded", "outline", "plain", "size", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ButtonTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}